export const Blogs = [
    {
        img: "https://www.timecamp.com/blog/wp-content/uploads/2019/08/time-tracking-for-architects-400x219.jpg",
        title: "13 Best Time Tracking Software for Architects",
        link:"https://www.timecamp.com/blog/2022/09/time-tracking-software-for-architects/"
        
    },
    {
        img: "https://www.timecamp.com/blog/wp-content/uploads/2022/09/remote-work-automation-header-400x219.jpg",
        title: "What Is An Automation For Remote Workers?",
        link:"https://www.timecamp.com/blog/2022/09/what-is-an-automation-for-remote-workers/"
    },
    {
        img: "https://www.timecamp.com/blog/wp-content/uploads/2018/05/project-time-tracking-min-300x164.jpg",
        title: "13 Best Tools for Project Time Tracking",
        link:"https://www.timecamp.com/blog/2022/09/best-tools-for-project-time-tracking/"
    }

]